import { matchCommands, type CapabilityCommand } from "../../core/capabilities";
import type { SuggestionProvider } from "../../core/suggestions";

// The `/` menu's rows, apart from the editor that shows them. They need the command registry and
// nothing else, so this file stands alone.

const GROUP_LABELS = { text: "Turn into", list: "Turn into", insert: "Insert" } as const;

export const SLASH_TRIGGER = "/";

/** The slash menu is a provider like any other: same engine, same menu, same keys. */
export const slashProvider = (commands: readonly CapabilityCommand[]): SuggestionProvider => ({
  id: "z-editor/slash",
  triggers: [SLASH_TRIGGER],
  allowSpaces: false,
  blockStartOnly: true,
  local: (query) =>
    matchCommands(commands, query).map((command) => ({
      key: command.id,
      label: command.label,
      description: GROUP_LABELS[command.group],
      commandId: command.id,
    })),
});
